import { Component, OnDestroy, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';

import { MonitorMenuService } from '../../core/services/dialog-services/monitor-menu.service';
import { ScreensStateService } from '../../core/services/screen-state/screens-state.service';

import { ScreenContentMode } from '../../core/enums/content-mode.enum';
import { ScreenContentStatus } from '../../core/enums/screen-status.enum';
import { BehaviorScreen } from '../../core/models/view-models/monitor-models/screen.type';

@Component({
  template: ``
})
export class BaseViewItemComponent implements OnInit, OnDestroy {
  @Input() public monitor: BehaviorScreen;

  public subscriptions: Subscription = new Subscription();
  public isSelected: boolean;
  public screenStatuses = ScreenContentStatus;
  public contentModes = ScreenContentMode;

  constructor(
    public selectionService: ScreensStateService,
    public monitorMenuService: MonitorMenuService
  ) {}

  ngOnInit(): void {
    const screenSub = this.selectionService.selectedScreensChanged.subscribe(
      data => {
        if (this.monitor) {
          this.isSelected = data.some(screen => this.monitor.MonitorHandler === screen.MonitorHandler);
        }
      }
    );

    this.subscriptions.add(screenSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onSelectionChanged() {
    if (this.isSelected) {
      this.selectionService.unselectScreen(this.monitor, true);
    } else {
      this.selectionService.selectScreen(this.monitor, true);
    }
  }

  handleCheckBoxClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    this.monitorMenuService.monitorContextMenuInstance?.componentInstance ?
      this.monitorMenuService.monitorContextMenuInstance.close() :
      this.onSelectionChanged();
  }
}
